import React from "react";
import { useT } from "@/i18n/I18nContext";
import MilestoneOverlay from "./MilestoneOverlay";

// Localised headline — inline copy, same pattern as WaterMilestone2LOverlay.
const COPY = {
  it: "Obiettivo passi raggiunto! 🚶",
  en: "Step goal reached! 🚶",
  de: "Schrittziel erreicht! 🚶",
  fr: "Objectif de pas atteint ! 🚶",
};

/**
 * Steps-goal celebration overlay — fires once per day from the Dashboard
 * as soon as today's synced steps cross the personal step target.
 */
export default function StepsGoalOverlay({ show, onClose, steps = null }) {
  const { lang } = useT();
  return (
    <MilestoneOverlay
      show={show}
      onClose={onClose}
      mascotSrc="/mascot/steps-512.png"
      mascotAlt="Solano"
      title={COPY[lang] || COPY.it}
      subtitle={steps ? `${Math.round(steps).toLocaleString()} 👟` : null}
      confettiColors={["#E8951C", "#22C5D5"]}
      size="lg"
      testId="steps-goal-overlay"
    />
  );
}
